import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e99ef4aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e99ef4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99ef4aa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ThemeStoresMobileIosAppSection: require('/app/components/ThemeStores/Mobile/Ios/AppSection.vue').default,ThemeStoresMobileIosScreenshots: require('/app/components/ThemeStores/Mobile/Ios/Screenshots.vue').default,ThemeStoresMobileIosAbout: require('/app/components/ThemeStores/Mobile/Ios/About.vue').default,ThemeStoresMobileIosRatingDisplay: require('/app/components/ThemeStores/Mobile/Ios/RatingDisplay.vue').default,ThemeStoresMobileIosPrivacy: require('/app/components/ThemeStores/Mobile/Ios/Privacy.vue').default,ThemeStoresMobileIosFooter: require('/app/components/ThemeStores/Mobile/Ios/Footer.vue').default})
